import { takeLatest, put, call, select } from 'redux-saga/effects';
import { GET_COST_SAGA } from "../sagaTypes";
import { loaderAction, addSubscriptionFormAction, oneTimeWorkoutFormAction, subscriptionFormAction } from "../rootReducer";
import { url } from "../../config";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";

const request = data => {
    return fetch(`${ url }/get_cost`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerGetCost(args) {
    const user = yield select(state => state.user);
    const currentEstablishment = yield select(state => state.currentEstablishment);
    const addSubscriptionForm = yield select(state => state.addSubscriptionForm);
    const subscriptionForm = yield select(state => state.subscriptionForm);
    const oneTimeWorkoutForm = yield select(state => state.oneTimeWorkoutForm);

    yield put(loaderAction(true));
    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);
        formData.append('establishment', currentEstablishment);
        formData.append('type', args.data.type);
        formData.append('times', args.data.times);
        formData.append('duration', args.data.duration);
        formData.append('coach', args.data.coach);
        formData.append('time_constraint', args.data.time_constraint);
        formData.append('request_type', args.data.request_type);
        formData.append('user', args.data.user || '');


        const response = yield call (request, formData);

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            // Если добавляем новый абонемент
            if (args.data.request_type === 'add_subscription') {
                yield put(addSubscriptionFormAction({
                    ...addSubscriptionForm,
                    payment: [{ index: 1, cost: response.cost, payment_method: { id: '', name: '' }}],
                    discount: { id: '', name: 'Нет скидки', percent: '0' },
                    total_sum: response.cost
                }));
            }
            // Если редактируем абонемент
            if (args.data.request_type === 'update_subscription') {
                yield put(subscriptionFormAction({
                    ...subscriptionForm,
                    payment: [{ index: 1, cost: response.cost, payment_method: { id: '', name: '' }}],
                    discount: { id: '', name: 'Нет скидки', percent: '0' },
                    total_sum: response.cost
                }));
            }
            // Если регистрируем разовую тренировку
            if (args.data.request_type === 'one_time') {
                yield put(oneTimeWorkoutFormAction({
                    ...oneTimeWorkoutForm,
                    payment: [{ index: 1, cost: response.cost, payment_method: { id: '', name: '' }}],
                    discount: { id: '', name: 'Нет скидки', percent: '0' },
                    total_sum: response.cost
                }));
            }
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        yield put(loaderAction(false));
    }
    finally {
        yield put(loaderAction(false));
    }
}

export default function* watcherGetCost() {
    yield takeLatest(GET_COST_SAGA, workerGetCost);
}